import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import Field from './Field';
var css = {
  "search": "rui-owJ3W",
  "option": "rui-RFqlr",
  "recentSearchItem": "rui-sRHR6",
  "suggestion": "rui-kudsJ",
  "suggestionCategory": "rui-1r1SF",
  "currentSearch": "rui-ToQNb",
  "icon": "rui-4Gsnj",
  "autosOption": "rui-BaHnN",
  "recentSearchHeading": "rui-ZStik",
  "lowercase": "rui-xbpMn",
  "header": "rui-cF4qg",
  "visible": "rui-eCpOG"
};
import Suggestion from './Suggestion';
import Suggestions from './Suggestions';
import classNames from 'classnames';
import RecentSearches from './RecentSearches';
import Icon from '../Icon/Icon';
var Search = /*#__PURE__*/function (_React$Component) {
  _inherits(Search, _React$Component);
  var _super = _createSuper(Search);
  function Search(props) {
    var _this;
    _classCallCheck(this, Search);
    _this = _super.call(this, props);
    _this.componentDidMount = function () {
      if (typeof document !== 'undefined') {
        document.addEventListener('keydown', _this.onKeyDown);
      }
    };
    _this.componentDidUpdate = function (_, prevState) {
      var _a, _b, _c;
      var _this$props = _this.props,
        value = _this$props.value,
        suggestions = _this$props.suggestions,
        getRecentSearches = _this$props.getRecentSearches,
        isAutosSearch = _this$props.isAutosSearch;
      if (!_this.state.focused && value !== _this.state.value) {
        _this.setState({
          value: value,
          suggestions: suggestions,
          selected: null
        });
      }
      if (_this.state.focused && !prevState.focused && isAutosSearch) {
        var _recentSearches = getRecentSearches();
        if (((_a = _recentSearches === null || _recentSearches === void 0 ? void 0 : _recentSearches[0]) === null || _a === void 0 ? void 0 : _a.title) !== ((_c = (_b = _this.state.recentSearches) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.title)) {
          _this.setState({
            recentSearches: _recentSearches
          });
        }
      }
    };
    _this.componentWillUnmount = function () {
      if (typeof document !== 'undefined') {
        document.removeEventListener('keydown', _this.onKeyDown);
      }
    };
    _this.onKeyDown = function (event) {
      var esc = 27;
      if (event.keyCode === esc) {
        _this.setState({
          focused: false
        });
      }
    };
    _this.onSubmit = function (event) {
      event.preventDefault();
      _this.submit();
    };
    _this.onReset = function (event) {
      event.preventDefault();
      _this.reset();
    };
    _this.submit = function () {
      _this.props.handler(_this.state.value);
    };
    _this.onRecentSearchSelect = function (title, index) {
      _this.setState({
        selected: null,
        focused: false
      });
      _this.props.handler({}, title, index);
    };
    _this.recentSearchRemoveHandler = function (event, recentSearchTerm) {
      var _a;
      event === null || event === void 0 ? void 0 : event.stopPropagation();
      event === null || event === void 0 ? void 0 : event.preventDefault();
      var recentSearches = (_a = _this.state.recentSearches) === null || _a === void 0 ? void 0 : _a.filter(function (item) {
        return item.title !== recentSearchTerm;
      });
      _this.props.removeRecentSearches(recentSearchTerm);
      _this.setState({
        recentSearches: recentSearches
      });
    };
    _this.reset = function () {
      if (_this.state.value) {
        _this.props.onReset();
        _this.setState({
          value: '',
          suggestions: [],
          selected: null
        });
      } else {
        _this.setState({
          visible: false
        });
      }
    };
    _this.showSearch = function () {
      _this.setState({
        visible: true,
        focused: true
      });
    };
    _this.change = function (value) {
      _this.setState({
        value: value,
        selected: null
      }, function () {
        _this.props.getSuggestions(_this.state.value);
      });
    };
    _this.focus = function () {
      _this.props.onFocus();
      _this.setState({
        focused: true
      });
    };
    _this.blur = function () {
      _this.props.onBlur();
      if (isNaN(parseInt(_this.state.selected, 10))) {
        _this.setState({
          selected: null,
          focused: false
        });
      }
    };
    _this.getFilteredRecentSearch = function () {
      var _a, _b;
      var val = '';
      if (typeof _this.state.value === 'string') {
        val = _this.state.value;
      } else if (_typeof(_this.state.value) === 'object') {
        val = _this.state.value.title;
      }
      var filteredRecentSearches = [];
      if (val && Array.isArray(_this.state.recentSearches)) {
        (_b = (_a = _this.state.recentSearches) === null || _a === void 0 ? void 0 : _a.forEach) === null || _b === void 0 ? void 0 : _b.call(_a, function (item) {
          var _a, _b, _c;
          var MAX_FILTERED_RS = 3;
          if (((_c = (_b = (_a = item.title) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes) === null || _c === void 0 ? void 0 : _c.call(_b, val === null || val === void 0 ? void 0 : val.toLowerCase())) && filteredRecentSearches.length < MAX_FILTERED_RS) {
            filteredRecentSearches.push(item);
          }
        });
      } else if (Array.isArray(_this.state.recentSearches)) {
        filteredRecentSearches = _this.state.recentSearches;
      }
      return filteredRecentSearches;
    };
    _this.select = function (option) {
      var suggestions = _this.props.suggestions;
      var recentSearches = _this.getFilteredRecentSearch();
      var selected = _this.state.selected;
      var values = {
        selected: option
      };
      if (suggestions.length || (recentSearches === null || recentSearches === void 0 ? void 0 : recentSearches.length)) {
        switch (option) {
          case 'none':
            values.selected = null;
            break;
          case 'prev':
            values.selected = selected ? parseInt(selected) - 1 : null;
            break;
          case 'current':
            if (!isNaN(parseInt(selected, 10))) {
              values.value = suggestions[selected];
              values.suggestions = _this.props.suggestions;
              values.selected = null;
            }
            break;
          case 'next':
            if (typeof selected === 'number') {
              var totalListItems = suggestions.length + recentSearches.length;
              values.selected = selected < totalListItems - 1 ? selected + 1 : selected;
            } else {
              values.selected = 0;
            }
            break;
        }
        _this.setState(values);
      }
      return values.selected;
    };
    _this.apply = function (option) {
      var _a;
      var recentSearchesLength = ((_a = _this.getFilteredRecentSearch()) === null || _a === void 0 ? void 0 : _a.length) || 0;
      var selectedIndex = option === 'current' ? _this.state.selected : option;
      var alteredIndex = selectedIndex - recentSearchesLength;
      var selectedValue = _this.props.suggestions[alteredIndex] || _this.state.recentSearches && _this.state.recentSearches[selectedIndex];
      var value = option === 'current' && selectedIndex == null ? _this.state.value : selectedValue || _this.state.value;
      _this.setState({
        value: value,
        selected: null,
        focused: false
      }, _this.submit);
    };
    var recentSearches = props.isAutosSearch && props.getRecentSearches();
    _this.state = {
      value: props.value,
      suggestions: props.suggestions,
      selected: null,
      focused: false,
      visible: false,
      recentSearches: recentSearches || []
    };
    return _this;
  }
  _createClass(Search, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var currentSuggestion = this.props.suggestions[this.state.selected];
      var _this$props2 = this.props,
        recentSearchIcon = _this$props2.recentSearchIcon,
        recentSearchTitle = _this$props2.recentSearchTitle,
        isAutosSearch = _this$props2.isAutosSearch;
      currentSuggestion = currentSuggestion && currentSuggestion.title ? currentSuggestion.title : '';
      var filteredRecentSearches = this.getFilteredRecentSearch();
      return /*#__PURE__*/React.createElement("form", {
        role: "search",
        style: this.props.style,
        onSubmit: this.onSubmit,
        onReset: this.onReset,
        className: classNames([css.search, this.props.className, this.state.visible ? css.visible : null, this.props.forceLowercase ? css.lowercase : null])
      }, /*#__PURE__*/React.createElement("button", {
        type: "submit",
        className: this.props.submitButtonClassName || '',
        "aria-label": "search",
        "data-aut-id": "btnSearch"
      }, this.props.submitButtonText), /*#__PURE__*/React.createElement(Field, {
        placeholder: this.props.placeholder,
        currentSuggestion: currentSuggestion,
        currentValue: this.state.value,
        onChange: this.change,
        onFocus: this.focus,
        onBlur: this.blur,
        onSelect: this.select,
        onApply: this.apply,
        onReset: this.reset,
        focus: this.state.visible || this.props.hasFocus,
        focused: this.state.focused
      }), /*#__PURE__*/React.createElement("button", {
        type: "reset",
        className: this.props.resetButtonClassName || '',
        "aria-hidden": !this.state.value,
        "aria-label": "reset"
      }, this.props.resetButtonText), /*#__PURE__*/React.createElement(Suggestions, {
        visible: this.state.focused,
        onMouseLeave: this.select
      }, /*#__PURE__*/React.createElement(React.Fragment, null, !!(filteredRecentSearches === null || filteredRecentSearches === void 0 ? void 0 : filteredRecentSearches.length) && !this.state.value && /*#__PURE__*/React.createElement("div", {
        className: css.recentSearchHeading
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: 'clock',
        size: 16.67,
        color: "primaryBase"
      }), /*#__PURE__*/React.createElement("p", null, recentSearchTitle))), /*#__PURE__*/React.createElement(React.Fragment, null, filteredRecentSearches.map(function (recentSearch, index) {
        return /*#__PURE__*/React.createElement(RecentSearches, {
          key: index,
          index: index,
          onSelect: _this2.onRecentSearchSelect,
          isSelected: index === _this2.state.selected,
          recentSearchTitle: recentSearch.title,
          recentSearchIcon: recentSearchIcon,
          onRemove: _this2.recentSearchRemoveHandler,
          onMouseOver: _this2.select,
          value: _this2.state.value
        });
      })), /*#__PURE__*/React.createElement(React.Fragment, null, this.props.suggestions.map(function (suggestion, index) {
        var alteredIndex = index + filteredRecentSearches.length;
        return /*#__PURE__*/React.createElement(Suggestion, {
          key: alteredIndex,
          index: alteredIndex,
          isSelected: alteredIndex === _this2.state.selected,
          onMouseOver: _this2.select,
          onClick: _this2.apply,
          suggestion: suggestion,
          icon: _this2.props.icon,
          isAutosSearch: isAutosSearch,
          value: _this2.state.value,
          translations: _this2.props.translations
        });
      }))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: this.props.submitButtonClassName || '',
        onClick: this.showSearch,
        "aria-label": "show search"
      }, this.props.submitButtonText));
    }
  }]);
  return Search;
}(React.Component);
Search.defaultProps = {
  value: '',
  placeholder: 'What are you looking for?',
  submitButtonText: 'Search',
  submitButtonClassName: '',
  resetButtonText: 'Cancel',
  resetButtonClassName: '',
  suggestions: [],
  className: '',
  style: {},
  forceLowercase: true,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onReset: function onReset() {},
  isFetchingSuggestions: false,
  icon: '',
  translations: {},
  getRecentSearches: function getRecentSearches() {},
  recentSearchIcon: null,
  recentSearchTitle: 'Recent searches',
  removeRecentSearches: function removeRecentSearches() {},
  isAutosSearch: false,
  hasFocus: true
};
export default Search;